import { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface StoreLoaderProps {
    wrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
}

export const getLoaderProps = (minHeight = "150px", size = 40): StoreLoaderProps => {
    return {
        wrapper: {
            css: css`
                min-height: ${minHeight};
                display: flex;
                align-items: center;
                justify-content: center;
            `,
        },
        spinner: {
            size,
        },
    };
};

export const getLoadingOverlayProps = (minHeight?: string, size = 40): LoadingOverlayProps => {
    const _minHeight = minHeight === undefined ? `${size}px` : minHeight;
    const _halfSize = size / 2;

    return {
        css: css`
            display: block;
            ${_minHeight ? `min-height: ${_minHeight};` : null}
        `,
        spinnerProps: {
            size,
            css: css`
                margin-top: -${_halfSize}px;
                margin-left: -${_halfSize}px;
            `,
        },
    };
};
